<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Svelte functions
	import { get } from 'svelte/store';
	//Types
	import type { Device } from 'src/types/Device';
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	//Stores
	//App Components
	import DeviceSettingsUnsupportedFw from './DeviceSettingsUnsupportedFW.svelte';
	// Design system components
	import { Alert } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	const _format = get(format);
	export let device: Device, setting;

	$: actualDevice = setting?.props?.device || device;
	$: statusStore = actualDevice?.id ? getDeviceStatus(actualDevice.id) : undefined;
	$: isOffline =
		actualDevice && actualDevice.id ? !$statusStore?.online : false;
</script>

{#if setting?.test_setting && (setting?.title !== 'sub_settings_title_warm_up' || !$showNewLayout)}
	<Alert
		class="mb-s"
		type="warning"
		heading={_format('title_test_setting', {
			default: 'This is a test setting.',
		})}
		isHeadingBold
		message={_format('description_test_setting', {
			default: 'You can see this because you are using a test user account.',
		})}
	/>
{/if}
{#if setting?.soon}
	<Alert
		type="info"
		heading={$format('alert_info_heading_coming_soon', {
			default: 'Coming soon',
		})}
		message={_format('alert_info_message_coming_soon', {
			default: 'This feature is coming soon.',
		})}
		isHeadingBold
	/>
{:else if setting?.unsupported_fw}
	{#if actualDevice}
		<svelte:component
			this={DeviceSettingsUnsupportedFw}
			device={actualDevice}
			values={setting.unsupported_fw}
			{isOffline}
		/>
	{/if}
{:else if setting.component}
	{#if typeof setting.component === 'object' && setting.component.component}
		<svelte:component this={setting.component.component} {...setting.component.props} />
	{:else if actualDevice}
		<svelte:component
			this={setting.component}
			{...setting?.props || {}}
			device={actualDevice}
			{isOffline}
			test_setting={setting?.test_setting}
		/>
	{/if}
{:else if setting?.text}
	{setting.text}
{/if}
